import { createContext, useContext } from 'react';

import { HoverMenuProps } from './HoverMenu';

export type HoverMenuContextState = {
  menuOpen: (props: Omit<HoverMenuProps, 'open'>) => void;
  menuClose: () => void;
  isDescendant: (node?: Node | null) => boolean;
};

export const HoverMenuContext = createContext<HoverMenuContextState | null>(null);

export const useHoverMenu = (): HoverMenuContextState => {
  const context = useContext(HoverMenuContext);
  if (!context) {
    throw new Error('useHoverMenu must be used within a HoverMenuProvider');
  }

  return context;
};
